import {
  Component,
  EventEmitter,
  Input,
  SimpleChanges,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { Store, select } from '@ngrx/store';

import { Router } from '@angular/router';
import { EDocumentStatus } from '@literax/enums/document.enum';
import { IAttachment } from '@literax/models/http/attachment.model';
import { IDocument } from '@literax/models/http/document/document.model';
import { attachments } from '@literax/modules/documents/store/document/document.selectors';
import { IAppState } from '@literax/store';
import { selectAttachments } from '@literax/store/free-document/free-document.selectors';
import { Observable } from 'rxjs';

import { IDocumentResponse } from '@literax/models/document.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
})
export class AttachmentsComponent implements OnChanges, OnInit {
  @Input() document: IDocument;
  @Input() documentsSecondary: IDocumentResponse[];
  @Input() mainDoc: IDocumentResponse;
  @Input() disabledActions: boolean;
  @Input() typePromissoryNote: boolean;
  @Output() attachmentSelected = new EventEmitter();
  @Output() replaceAttachment = new EventEmitter();
  @Output() editAttachment = new EventEmitter();
  @Output() checkAttachmentId = new EventEmitter();

  attachments$ = this.store.pipe(untilDestroyed(this), select(attachments));
  freeDocumentAttachments$ = this.store.pipe(
    untilDestroyed(this),
    select(selectAttachments)
  );

  attachments: Partial<IAttachment>[] = [];
  mainDocument: Partial<IAttachment>;
  edit: boolean;

  @Input() workarea: 'free' | 'account' | 'promissory_note' = 'account';
  showCheckAttachment = false;

  constructor(private router: Router, private store: Store<IAppState>) {}

  ngOnInit(): void {
    const AttachmentKey = this.document?.status?.key;
    const isUserSigner = this.document?.user_signer?.length > 0;
    this.showCheckAttachment =
      isUserSigner &&
      (AttachmentKey === EDocumentStatus.APPROVAL ||
        AttachmentKey === EDocumentStatus.REVIEW);
    this.findDocumentsAttachments();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.document && this.document) {
      const attachmentKey = this.document?.status?.key;
      const isUserSigner = this.document?.user_signer?.length > 0;
      this.showCheckAttachment =
        isUserSigner &&
        (attachmentKey === EDocumentStatus.APPROVAL ||
          attachmentKey === EDocumentStatus.REVIEW);
    }

    if (
      this.typePromissoryNote &&
      (changes.mainDoc || changes.documentsSecondary)
    ) {
      this.attachments = [];
      this.mainDocument = undefined;
      this.findDocumentsAttachments();
    }
  }

  setupAttachments(observable: Observable<IAttachment[]>): void {
    // observable.subscribe((attachments) => {
    //   const documentInfo = {
    //     id: this.document.id,
    //     status: this.document.status,
    //   };
    //   this.edit = this.document?.status?.key === 'draft';
    //   this.attachments = attachments.map((el: IAttachment) => ({
    //     ...el,
    //     documentInfo,
    //   }));
    //   this.mainDocument = this.attachments.find((element) => element.primary);
    //   if (this.mainDocument) {
    //     this.attachments = this.attachments.filter(
    //       (attachment) => attachment.id !== this.mainDocument.id
    //     );
    //     this.typePromissoryNote =
    //       this.mainDocument.kind === 'promissory_note' ||
    //       this.mainDocument.kind === 'template';
    //   }
    // });
  }

  attachmentDetail(attachmentId: number) {
    this.attachmentSelected.emit(attachmentId);
  }

  checkAttachment(attachmentId: number) {
    this.checkAttachmentId.emit(attachmentId);
  }

  goToSign(documentId: number) {
    this.router.navigate([`/platform/documents/${documentId}`]);
  }

  findDocumentsAttachments() {
    if (this.mainDoc) {
      this.mainDocument = {
        id: this.mainDoc.attachments[0].id,
        name: this.mainDoc.attachments[0].name,
        text: this.mainDoc.attachments[0].filePlainText,
        kind: this.mainDoc.attachments[0].kindName
          .toString()
          .toLocaleLowerCase(),
        multilanguage: this.mainDoc.attachments[0].multilanguage,
        documentInfo: { id: this.mainDoc.id, status: this.mainDoc.status },
        primary: this.mainDoc.attachments[0].primary,
      };
    }

    if (this.documentsSecondary?.length) {
      const seen = new Set<number>(this.attachments.map((a) => a.id as number));

      this.documentsSecondary.forEach((document) => {
      const att = document.attachments?.[0];
      if (!att?.id) return;

      // Evita duplicados por id de attachment
      if (seen.has(att.id)) return;
      seen.add(att.id);

      const documentInfo = { id: document.id, status: document.status };
      this.attachments.push({
        id: att.id,
        name: att.name,
        text: att.filePlainText,
        kind: att.kindName.toString().toLocaleLowerCase(),
        multilanguage: att.multilanguage,
        primary: att.primary,
        documentInfo,
      });
      });
    }
  }
}
